import {unwrapResult} from '@reduxjs/toolkit';
import React, {memo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {UiAppointmentBookingLayout} from '~/components/elements/UiAppointmentBookingLayout';
import {APPOINTMENT_BOOKING_DESCRIPTIONS, TIME_LIST} from '~/constants/appointment-bookings';
import {useInput, useNotification, useRequestState} from '~/hooks';
import {bookAppointment} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';
import {setAppointmentSorryModal} from '~/redux/ui/slice';
import {requestOK} from '~/utils/thunk-api';
import {redirectInIframe} from '~/utils/helpers';

interface Props {}

const StdTestingAppointmentBooking = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);
  const userQuestionnaireId = useSelector((state: RootState) => state.questionnaires.userQuestionnaireId);
  const isWebview = useSelector((state: RootState) => state.questionnaires.isWebview);
  const {loading} = useRequestState(bookAppointment);

  const [redirectLoading, setRedirectLoading] = useState(false);

  const {inputs, setInputs} = useInput({
    selectedDate: undefined,
    selectedTime: undefined,
  });

  const onChangeDate = (value?: Date) => {
    if (value) {
      setInputs({selectedDate: value});
    }
  };

  const onChangeTime = (value?: Date) => {
    setInputs({selectedTime: value});
  };

  const onClickSubmit = async () => {
    const resAction = await dispatch(
      bookAppointment({
        data: {startTime: inputs.selectedTime, userQuestionnaireId},
        platform: isWebview ? 1 : 2,
      }),
    );
    if (requestOK(resAction, bookAppointment)) {
      const result = unwrapResult(resAction);
      if (result.checkoutURL) {
        setRedirectLoading(true);
        redirectInIframe(result.checkoutURL, '_blank');
      }
    } else {
      dispatch(setAppointmentSorryModal());
    }
  };

  return (
    <UiAppointmentBookingLayout
      descriptions={APPOINTMENT_BOOKING_DESCRIPTIONS.STD_TESTING}
      dateValue={inputs.selectedDate}
      timeValue={inputs.selectedTime}
      onChangeDate={onChangeDate}
      onChangeTime={onChangeTime}
      loading={loading || redirectLoading}
      timeSelectionTitle="Slots available on"
      handleOnNext={onClickSubmit}
      disableNext={!inputs.selectedDate || !inputs.selectedTime || loading || redirectLoading}
      selectTimePlaceholder={'Select time slot'}
      showEndTime
      note="You'll receive a text message confirming your exact time slot."
    />
  );
};

export default memo(StdTestingAppointmentBooking);
